// Entry file that bundles all required scripts for webpack output when source is in wwwroot

// Do not import bootstrap here; it's included via layout as /lib/bootstrap/dist/js/bootstrap.bundle.min.js

// Import existing site scripts (relative to wwwroot/js)
import './site.js';
import './hub-client.js';
import './notifications.js';
import './share.js';
import './share-init.js';
import './admin-push.js';
